export default "__VITE_ASSET__DRYhTQ0F__"